import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastMensajeService {

  private mensajeOKFuente = new BehaviorSubject<string>('');
  private mensajeErrorFuente = new BehaviorSubject<string>('');
  private tiempoPorDefecto = 5000; // Tiempo en milisegundos
  private tiempoOK: any;
  private tiempoError: any;

  public mensajeOK$ = this.mensajeOKFuente.asObservable();
  public mensajeError$ = this.mensajeErrorFuente.asObservable();

  mostrarMensajeOK(texto: string, tiempo = this.tiempoPorDefecto) {
    clearTimeout(this.tiempoOK); // Cancelamos el temporizador anterior
    this.mensajeOKFuente.next(texto);
    this.tiempoOK = setTimeout(() => this.mensajeOKFuente.next(''), tiempo);
  }

  mostrarMensajeError(texto: string, tiempo = this.tiempoPorDefecto) {
    clearTimeout(this.tiempoError); // Cancelamos el temporizador anterior
    this.mensajeErrorFuente.next(texto);
    this.tiempoError = setTimeout(() => this.mensajeErrorFuente.next(''), tiempo);
  }
}
